import {
  Box,
  Container,
  Typography,
  Button,
  Stack,
  useTheme,
  useMediaQuery,
  Avatar,
} from "@mui/material";
import { FpwdTitle, RootBox } from "./mui.styles";
import { FORM_VALIDATIONS } from "constants/formValidation";
import { Controller, useForm } from "react-hook-form";
import { ROUTES } from "constants/routes";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { useAppDispatch } from "store/appHooks";
import { handleSnackBar } from "slices/global";
import { useState } from "react";
import MESSAGES from "constants/messages";
import { useNavigate } from "react-router-dom";
import { CustomTextField } from "components/mui-common/CustomTextField";
import AuthPagesDescription from "components/AuthPagesDescription";
import { LoginTitle } from "components/login/mui.styles";
import LockResetIcon from "@mui/icons-material/LockReset";
import PasswordIcon from "@mui/icons-material/Password";

const ForgotPassword = () => {
  const { control, handleSubmit, setValue } = useForm({
    mode: "onChange",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const isMobileView = useMediaQuery(theme.breakpoints.down("md"));

  const resetPassword = (data: any) => {
    setIsSubmitting(true);
    const auth = getAuth();
    sendPasswordResetEmail(auth, data.email)
      .then((result) => {
        console.log(result);
        setValue("email", "");
        dispatch(
          handleSnackBar({
            open: true,
            message: MESSAGES.RESET_LINK_SENT,
            severity: "success",
          })
        );
        navigate(ROUTES.SIGNIN);
        setIsSubmitting(false);
      })
      .catch((error) => {
        setIsSubmitting(false);
        if (error.code === "auth/user-not-found") {
          dispatch(
            handleSnackBar({
              open: true,
              severity: "error",
              message: "User is not exists with this email address.",
            })
          );
          return;
        }
        dispatch(
          handleSnackBar({
            open: true,
            message: error.message,
            severity: "error",
          })
        );
      });
  };

  return (
    <Box
      sx={{
        backgroundColor: isMobileView ? "transparent" : "primary.main",
        minHeight: isMobileView ? "100%" : "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={8}
        sx={{ width: "100%", height: "100vh" }}
      >
        {!isMobileView && (
          <Box sx={{ width: 450 }}>
            <AuthPagesDescription />
          </Box>
        )}
        <RootBox
          sx={{
            maxWidth: isMobileView ? "100%" : "384px",
            ...(isMobileView && { width: "100%", height: "100%" }),
          }}
        >
          <Box p={3.5}>
            <form onSubmit={handleSubmit(resetPassword)}>
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={2}
              >
                {/* <Box>
                  <Avatar alt="Remy Sharp" sx={{ width: 80, height: 80, backgroundColor: "primary.main" }}>
                    <PasswordIcon sx={{fontSize: "60px"}}/>
                  </Avatar>
                </Box> */}

                <LoginTitle
                  sx={{
                    textAlign: "left !important",
                    fontSize: "28px !important",
                  }}
                >
                  Forget your account password?
                </LoginTitle>
                <Typography
                  fontSize={"15px"}
                  fontWeight={400}
                  lineHeight="22px"
                >
                  {" "}
                  Enter the email you used to create your account so we can send
                  you link for reset your password.
                </Typography>
                <br />
                <br />
                <Controller
                  control={control}
                  name="email"
                  rules={{ ...FORM_VALIDATIONS.REQUIRED_EMAIL }}
                  render={({ field: { onChange }, fieldState: { error } }) => (
                    <CustomTextField
                      variant="standard"
                      placeholder="Email"
                      fullWidth
                      onChange={onChange}
                      error={!!error}
                      helperText={error?.message ?? ""}
                    />
                  )}
                />
 <br />
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  disabled={isSubmitting}
                  size="large"
                >
                  Submit
                </Button>

                <Typography
                  color="#565656"
                  sx={{ textAlign: "center" }}
                  fontSize={12.5}
                  mt={2}
                  fontWeight={500}
                >
                  Remember your password ?{" "}
                  <Typography
                    component="a"
                    color="primary"
                    fontSize={12.5}
                    mt={1}
                    fontWeight={500}
                    onClick={() => navigate(ROUTES.SIGNIN)}
                    sx={{ cursor: isSubmitting ? "not-allowed" : "pointer" }}
                  >
                    Back to Login
                  </Typography>
                </Typography>
              </Stack>
            </form>
          </Box>
        </RootBox>
      </Stack>
    </Box>
  );
};

export default ForgotPassword;
